import { useContext } from 'react';
import GoBack from '../../components/GoBack/GoBack';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import { LanguageContext } from '../contexts/Language.context';
import { ThemeContext } from '../contexts/Theme.context';
import useLongPress from '../utils/useLongPress';
import styles from './PageHeader.style';

export default function PageHeader({
  backButton = false,
  showLanguageSelector = true,
  onLongPress = () => {},
  showShareButton = false,
}) {
  const { state: theme } = useContext(ThemeContext);
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const longPressEvent = useLongPress(onLongPress);

  return (
    <div className={'header-content'}>
      <div className={'back-button-container'}>{backButton ? <GoBack /> : null}</div>
      {!theme.isIframe || !theme.canUseIframe ? (
        <>
          <div className={'image-container'}>
            {theme.logo && (
              <img
                className={'img-header'}
                src={theme.logo}
                alt="Civitfun header logo"
                {...longPressEvent}
              ></img>
            )}
          </div>
          <div className={'language-container'}>
            {showLanguageSelector ? <LanguageSelector /> : null}
          </div>
        </>
      ) : null}

      <style jsx>{styles}</style>
    </div>
  );
}
